// import { configureStore } from "@reduxjs/toolkit";
// import userSlice from "../redux/slices/user";
// // Set central Store for Your Application
// export const store = configureStore({
//   reducer: {
//     user: userSlice,
//   },
// });
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { rootReducer } from "./rootReducers";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: ["counter"], // What you don't wanna to persist
  whitelist: ["auth"], // What you want to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
